// extracted by mini-css-extract-plugin
export default {"description":"style_description__zXVbE","fade-in":"style_fade-in__6YsV8","top":"style_top__Yy8BG","image":"style_image__9QsxT"};